<template>
    <div class="container">
        <span @click="$emit('close')" role="button"><small><i class="fa-solid fa-chevron-left me-2"></i>{{ $t('common.back') }}</small></span>
        <h2 class="my-3">{{ $t('modal.addReminder') }}</h2>
        <div class="mb-3">
            <label for="descriptionInput" class="form-label"><small>{{ $t('modal.content') }}</small></label>
            <textarea id="descriptionInput" class="form-control bg-light" v-model="reminder" required
                :placeholder="$t('modal.reminderPlaceholder')"></textarea>
        </div>

        <div class="row mt-3">
            <div class="col">
                <button @click="$emit('close')" class="btn border-1 border-primary text-primary w-100" :disabled="actionInProgress">{{ $t('common.cancel') }}</button>
            </div>
            <div class="col">
                <button @click="submitReminder" class="btn btn-primary w-100" :disabled="actionInProgress">{{ $t('modal.add') }}</button>
            </div>
        </div>

    </div>
</template>


<script>
import axios from '@/services/axios';

export default {
    props: {
        objectId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            reminder: '',
            // Held only while the request is in flight, so a slow network
            // cannot turn one click into two records.
            actionInProgress: false,
        };
    },
    methods: {
        async submitReminder() {
            if (this.actionInProgress) return;
            this.actionInProgress = true;
            try {
                const response = await axios.post(`/objects/${this.objectId}/reminders`, { reminder: this.reminder });

                if (response.status === 200) {
                    this.$emit('reminder-added', response.data.data);
                    this.reminder = '';
                    this.$emit('close');
                }

            } catch (error) {
                console.error('Error adding reminder:', error);
            } finally {
                this.actionInProgress = false;
            }
        }
    }
};
</script>


<style scoped></style>
